// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Autoplay, Keyboard } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_hero-banner.scss';

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--homepage-hero';
const CAROUSEL_CLASS = 'carousel--homepage-hero';
const CAROUSEL_SECTION_SELECTOR = '.carousel-section--homepage-hero';
const CAROUSEL_SECTION_CLASS = 'carousel-section--homepage-hero';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
function handleRotatingBannersSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= window.innerHeight &&
            slidePos.right <= window.innerWidth)) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - (window.innerHeight / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}


document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
        .forEach((element, index) => {
            
            // Generate unique class for each collection list slider
            element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

            // Generate unique btn classes for slider arrows
            element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
            element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

            // Generate unique btn classes for swiper pagination
            element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

            const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
                // Optional parameters
                modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Autoplay],
                slidesPerView: 1,
                spaceBetween: 15,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
                autoplayDisableOnInteraction: true,
                observer: true,
                observeParents: true,
                a11y: false,
                watchOverflow: true,
                loop: false,

                navigation: {
                    nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                    prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
                },

                pagination: {
                    el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                    type: 'bullets',
                    clickable: true,
                },
                on: {
                    beforeInit() {
                      const slides = this.el.querySelectorAll('.swiper-slide');
                
                      if (slides) {
                        // this.params.loop = slides.length > 1;
                        this.params.autoplay.enabled = slides.length > 1;
                      }
                    },
                  }
            });

            const swiperContainer = document.getElementById("heroSwiper");
            
            swiperContainer.addEventListener("mouseover", (e) => {
                swiper.autoplay.pause();
            });

            swiperContainer.addEventListener("mouseleave", (e) => {
                swiper.autoplay.start();
            });

            swiperContainer.addEventListener("click", () => {
                swiper.autoplay.stop();
            });
    
            if (swiper.slides) {
                handleRotatingBannersSlides(swiper);
            } else {
                swiper.forEach(function(swiperEl) {
                    handleRotatingBannersSlides(swiperEl);
                })
            }
        })
